import React, { useEffect } from 'react';
import { initMetaPixel } from './utils/metaPixel';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { TomosSection } from './components/TomosSection';
import { BonosSection } from './components/BonosSection';
import { PricingSection } from './components/PricingSection';
import { ModuleSection } from './components/ModuleSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FaqSection } from './components/FaqSection';
import { CostSection } from './components/CostSection';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { PurchaseToast } from './components/PurchaseToast';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-full w-full bg-ink font-sans" data-id="element-0" data-mp="23vkv2fqfs7kp">
      <Hero data-id="element-1" data-mp="23v2rsz5cwt3a" />
      <main data-id="element-2" data-mp="23t8ea5wf0398">
        <ProblemSection data-id="element-3" data-mp="3ijxqiu0iq6lh" />
        <TomosSection data-id="element-4" data-mp="3ikr002qv3a7b" />
        <BonosSection data-id="element-5" data-mp="3ij668fcdfvai" />
        <PricingSection data-id="element-6" data-mp="3ihv1odb3qjic" />
        <ModuleSection data-id="element-7" data-mp="3mlj8uuvtnd32" />
        <TestimonialsSection data-id="element-8" data-mp="3mkrefndynled" />
        <GuaranteeSection data-id="element-9" data-mp="3mjzu58ptda3e" />
        <FaqSection data-id="element-10" data-mp="3mj6jvxrnc2gi" />
        <CostSection data-id="element-11" data-mp="3rcj846sey78q" />
        <FinalCta data-id="element-12" data-mp="3rdaquh0wwahl" />
      </main>
      <Footer data-id="element-13" data-mp="3rd19tixuhdo1" />
      <PurchaseToast data-id="element-14" data-mp="3reltgdimfc74" />
    </div>;
}